import { useCallback, useMemo, useState } from 'react';
import type { PredictionMarketsPriceGridFilterState } from './types';

export function usePredictionMarketsPriceGridFilter({
  filterState: persistedFilterState,
  onFilterStateChanged,
}: {
  filterState?: PredictionMarketsPriceGridFilterState;
  onFilterStateChanged?: (filterState: PredictionMarketsPriceGridFilterState) => void;
}) {
  const [filterState, setFilterState] = useState<PredictionMarketsPriceGridFilterState>(persistedFilterState ?? {});

  const setFilterStateAndNotify = useCallback(
    (nextFilterState: PredictionMarketsPriceGridFilterState) => {
      setFilterState(nextFilterState);
      onFilterStateChanged?.(nextFilterState);
    },
    [onFilterStateChanged]
  );

  const setSearch = useCallback(
    (search: string) => {
      setFilterStateAndNotify({
        ...filterState,
        search: search.length === 0 ? undefined : search,
      });
    },
    [filterState, setFilterStateAndNotify]
  );

  return useMemo(
    () => ({ filterState, setFilterState: setFilterStateAndNotify, setSearch }),
    [filterState, setFilterStateAndNotify, setSearch]
  );
}
